import KnowledgeGapsMap from './KnowledgeGapsMap';

export default KnowledgeGapsMap;
